<template>
	<section class="section-contact" id="contact">
		<div class="container">
			<div class="row justify-content-center">
				<img src="@/assets/img/divider.png" class="divider" />
			</div>
			<div class="row justify-content-center contact-form">
				<div class="col-lg-7 col-md-8 col-sm-12 margin-vertical">
					<h1 v-if="this.emergency">Emergency Contact</h1>
					<h1 v-else-if="this.cat === 'hosts' || this.cat === 'enterprise'">Get Started</h1>
					<h1 v-else>Contact Us</h1>

					<p v-if="this.cat === 'gaming' || this.cat === 'servers'">Have a question? Reach out to our team and we'll help you out.</p>
					<div v-else-if="this.cat === 'hosts' || this.cat === 'enterprise' || this.emergency"><p style="margin-bottom: 12px;">Our team is ready to help.</p><p style="margin-bottom: 24px;">Please fill out the form with your information and we'll get back to you<br>as soon as possible to get started.</p></div>
					<p v-else>Let's get connected.</p>

					<form action="https://formspree.io/mlepoyza" method="POST">
						<input id="contact-subject" type="hidden" name="_subject" v-model="contactSubject" />
						<div class="container-fluid">
							<div class="row">
								<div class="col-2 label-col">
									<div class="row">
										<label for="contact-name">Name:</label>
									</div>
									<div class="row">
										<label for="contact-email">Email:</label>
									</div>
									<div class="row">
										<label for="contact-message">Message:</label>
									</div>
								</div>
								<div class="col-10 col-lg-8 input-col">
									<div class="row">
										<input id="contact-name" type="text" name="name" />
									</div>
									<div class="row">
										<input id="contact-email" type="text" name="_replyto" v-model="contactEmail" />
									</div>
									<div class="row">
										<textarea id="contact-message" type="text" name="message"></textarea>
									</div>
									<div class="row">
										<button class="button-global" type="submit">Submit</button>
									</div>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="col-xl-4 col-lg-5 col-md-8 col-sm-12 margin-vertical d-flex" v-if="emergency">
					<div class="guardian-cont mt-auto mb-auto" style="width: 100%;">
						<img src="@/assets/img/guardian.png" class="guardian-img" alt="">
						<div class="row mt-auto">
							<div class="col-12 text-index" style="margin-top: 1.1em;">
								<h2>Cosmic Guardian</h2>
								<h4>Deploy live in minutes,<br>mitigate attacks in seconds.</h4>
							</div>
						</div>
						<div class="row mt-2 mb-auto d-flex">
							<router-link to="/signup" class="signup-btn">
								<button class="create-btn" style="padding: 0 !important; width: 225px !important; height: 2.9em;"><span>Create Account</span></button>
							</router-link>
						</div>
					</div>
				</div>
				<div class="col-md-5 col-lg-4 offset-lg-1 d-none d-md-block" v-else>
					<img class="satellite" src="@/assets/img/contact_satellite.png" />
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "ContactUs",
	data() {
		return {
			contactSubject: "",
			contactEmail: "",
		}
	},
	props: {
		emergency: {
			type: Boolean,
			default: false,
		},
		cat: {
			type: String,
			default: null,
		},
	},
	watch: {
		contactEmail: function(newEmail) {
			this.contactSubject = "Contact (" + newEmail + ")";
		},
	},
}
</script>

<style scoped>
@media only screen and (max-width: 576px) {
	.margin-vertical {
		margin: 0.5em auto;
	}
}
.guardian-cont {
	overflow: hidden;
	padding: 1.75em 2em;
	min-height: 12em;
	border-radius: 5px;
	background-color: #10161F;
	display: flex;
	flex-direction: column;
}
.guardian-img {
	position: absolute;
	float: right;
	z-index: 0;
	right: 0;
	top: 3em;
	width: 15em;
	max-width: none;
}
.signup-btn {
	margin-left: auto;
	margin-right: auto;
}
.signup-btn > button {
	width: 200px !important;
}
.text-index {
	z-index: 10;
}

.divider {
    position: relative;
    top: -9px;
    width: 300px;
	height: 20px;
}

@media only screen and (max-width: 540px) {
	.divider {
	    top: -7px;
	    width: 230px;
		height: 15px;
	}
}

@media only screen and (max-width: 230px) {
	.divider {
		height: auto;
	}
}

.section-contact {
	padding-bottom: 3em;
}

.section-contact h1 {
    margin: 0px;
    color: #427ed6;
    margin-bottom: 0.25em;
}

.section-contact label {
    font-weight: 600;
}

.contact-form {
    padding: 2em 0em;
}

@media only screen and (max-width: 600px) {
    .contact-form {
        padding: 0em;
    }
}

.section-contact form input, textarea {
    width: 100%;
	border: 1px solid #004395;
	border-radius: 5px;
	padding: 5px 10px;
    color: black;

    text-transform: none;
}

.container-fluid {
    padding: 0px;
    margin: 0px;
}
.container-fluid > .row {
    margin: 0px;
}
.label-col {
	padding-left: 0;
    padding-right: 4em;
}

@media only screen and (max-width: 992px) {
    .label-col {
        padding-right: 3em;
    }
    .section-contact form input, textarea {
        width: 90%;
        margin-left: 1em;
    }
    .section-contact form button {
        width: 90%;
        margin-left: 1em;
    }
	.input-col {
		margin: 0px !important;
	}
}

form .input-col {
    padding: 0px;
    margin: 0 0 0 20px;
}

.input-col input {
    line-height: 1em;
}

form .row {
    margin-left: 0px;
    margin-bottom: 8px;
}

.satellite {
    min-width: 290px;
    max-width: 290px;
    margin-left: 2em;
}
input {
	font-weight: 400;
}
</style>
